import React from 'react'
import {WebsiteInitialData_CachedQuery} from '@data/__generated__/types.main'

export default React.createContext<WebsiteInitialData_CachedQuery>(null)
